function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEmoji = function SvgEmoji(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M10 19c5 0 9-4 9-9s-4-9-9-9-9 4-9 9 4 9 9 9zM6.5 8C7.3 8 8 7.3 8 6.5S7.3 5 6.5 5 5 5.7 5 6.5 5.7 8 6.5 8zm3.5 8c2.2 0 4-2.2 4-5H6c0 2.8 1.8 5 4 5zm5-9.5c0 .8-.7 1.5-1.5 1.5S12 7.3 12 6.5 12.7 5 13.5 5s1.5.7 1.5 1.5z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    }
  }));
};
export default SvgEmoji;